// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__xy7fD","errorLogs":"EditorFooter_errorLogs__2iRhA"};